module.exports = __webpack_public_path__ + "static/media/Tres.209acf9b.png";